/**
 * Created by akirilyuk on 11/15/16.
 *
 * This model is used to retrive the AccountName and the salesforceId information in order to create a Case
 *
 *
 *
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var ApiResources = require("assets/data/apiResources.json");
    var LEResourceResolver = require("leResourceResolver");

    var AccountInfoModel = {};
    var KEYS = {
        ACCOUNT_NAME : "accountName",
        SALESFORCE_ID : "salesForceID",
        CAN_ADD_SEVERITY: "canAddSeverity"
    };
    LE.module("LEContent", function () {

        AccountInfoModel = BaseModel.extend({
            resource: ApiResources.ConnectionPanel.AccountInfoModel,

            initialize: function (options) {
                options = options || {};
                this.resource.url = LEResourceResolver.getUrl(this.resource.url);
            },
            getAccountName: function(){
                return this.get(KEYS.ACCOUNT_NAME);
            },
            getSalesForceId: function(){
                return this.get(KEYS.SALESFORCE_ID);
            },
            canAddSeverity: function () {
                return this.get(KEYS.CAN_ADD_SEVERITY) === true;
            },
            name: "AccountModel"
        });
    });
    AccountInfoModel.KEYS = KEYS;
    return AccountInfoModel;
});
